import { bool, object, ref, string } from 'yup'

import { validateField, validateValues } from 'shared/utils/form'
import { passwordRegex } from 'shared/utils/validators'

type RegistrationValues = {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  password: string
  passwordConfirmation: string
  regulationsAccepted: boolean
  smsConsentsGranted: boolean
}

export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

// REGISTRATION
export const registrationSchema = object().shape({
  firstName: string()
    .trim()
    .required('Imię jest wymagane')
    .min(3, 'Imię zbyt krótkie')
    .matches(/^\D*$/, {
      message: 'Nieprawidłowy format imienia'
    }),
  lastName: string()
    .trim()
    .required('Nazwisko jest wymagane')
    .min(3, 'Nazwisko zbyt krótkie')
    .matches(/^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+(-[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+)*$/, {
      message: 'Nieprawidłowy format nazwiska'
    }),

  phoneNumber: string()
    .required('Numer telefonu jest wymagany')
    .min(9, 'Numer telefonu musi mieć dziewięć cyfr')
    .max(9, 'Numer telefonu musi mieć dziewięć cyfr')
    .matches(/^\d{9}$/, 'Nieprawidłowy format'),

  email: string()
    .required('Email jest wymagany')
    .matches(emailRegex, 'Niepoprawny adres email')
    .email('Niepoprawny adres email'),
  password: string()
    .required('Hasło jest wymagane')
    .matches(passwordRegex, 'Niepoprawny format hasła'),
  passwordConfirmation: string()
    .required('Powtórzenie hasła jest wymagane')
    .oneOf([ref('password')], 'Podane hasła muszą być identyczne'),
  // postalCode: string().test(
  //   'is-present',
  //   'Kod pocztowy jest wymagany',
  //   function (value) {
  //     const { path, createError } = this
  //     const phoneNumber = this.resolve(ref(path))
  //
  //     if (isNilOrEmpty(phoneNumber)) return true
  //     if (value && !/\d{2}-\d{3}/.test(value)) {
  //       return createError({ path, message: 'Nieprawidłowy format' })
  //     }
  //
  //     return true
  //   }
  // ),
  regulationsAccepted: bool()
    .required('Aby kontynuować musisz zaakceptować regulamin')
    .oneOf([true], 'Aby kontynuować musisz zaakceptować regulamin'),
  smsConsentsGranted: bool().required(),
  isNewsletterSubscriber: bool().optional(),
  verificationSmsCode: string().optional(),
  allAgreementsConsent: bool().optional()
})

export const validateRegistrationField = (values: RegistrationValues) =>
  validateField(registrationSchema, values)

export const validateRegistrationValues = validateValues(registrationSchema)
